import { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import confetti from "canvas-confetti";
import "./campaign.css";
import ReactPlayer from "react-player";
import { campaignFetcher } from "../../api/requests";
import { useParams, useHistory } from "react-router-dom";
import { baseURL } from "../../api/dataFetcher";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import LoadingIndicator from "../Atomics/Loading/Loading";

export const getMedalAndRank = (medal) => {
  switch (medal) {
    case "Gold":
      return "🥇 مدال طلا - رتبه اول";
    case "Silver":
      return "🥈 مدال نقره - رتبه دوم";
    case "Bronze":
      return "🥉 مدال برنز - رتبه سوم";
    case "4":
    case "Fourth":
      return "🏅 رتبه چهارم";
    case "5":
    case "Fifth":
      return "🏅 رتبه پنجم";
    case "6":
    case "Sixth":
      return "🏅 رتبه ششم";
    case "7":
    case "Seventh":
      return "🏅 رتبه هفتم";
    case "8":
    case "Eighth":
      return "🏅 رتبه هشتم";
    case "9":
    case "Ninth":
      return "🏅 رتبه نهم";
    case "10":
    case "Tenth":
      return "🏅 رتبه دهم";
    default:
      return medal ? `رتبه ${medal}` : "بدون رتبه";
  }
};

const CampaignResult = () => {
  const [results, setResults] = useState([]);
  const params = useParams();
  const campaignId = params.id;
  const history = useHistory();
  const [currentIndex, setCurrentIndex] = useState(0);
  const currentResult = results[currentIndex];

  useEffect(() => {
    confetti({
      particleCount: 80,
      spread: 70,
      origin: { y: 0.6 },
    });

    const duration = 500;
    const end = Date.now() + duration;

    const frame = () => {
      confetti({
        particleCount: 10,
        angle: 60,
        spread: 55,
        origin: { x: 0 },
      });

      confetti({
        particleCount: 10,
        angle: 120,
        spread: 55,
        origin: { x: 1 },
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    };

    frame();
    getResult();
  }, []);

  const getResult = async () => {
    try {
      const res = await campaignFetcher.getCampaignResult(campaignId);

      if (res.count) {
        setResults(res.results);
        setCurrentIndex(0);
      } else {
        history.push("/404");
      }
    } catch (err) {
      console.error(err);
    } finally {
    }
  };

  return (
    <>
      <ContentWrapper className="single-channel-page campaign-result-page">
        <Container fluid>
          <div className="campaignContainer">
            <div className="body">
              <h2
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <button
                  onClick={() =>
                    setCurrentIndex((prev) => Math.max(prev - 1, 0))
                  }
                  disabled={currentIndex === 0}
                  style={{
                    cursor: currentIndex === 0 && "not-allowed",
                  }}
                >
                  <FontAwesomeIcon icon={faArrowRight} fixedWidth />
                </button>
                {currentResult?.campaign?.name}
                <button
                  onClick={() =>
                    setCurrentIndex((prev) =>
                      Math.min(prev + 1, results.length - 1)
                    )
                  }
                  disabled={currentIndex === results.length - 1}
                  style={{
                    cursor:
                      currentIndex === results.length - 1 && "not-allowed",
                  }}
                >
                  <FontAwesomeIcon icon={faArrowLeft} fixedWidth />
                </button>
              </h2>

              <div className="video-player-wrapper">
                {currentResult?.video_post_campaign?.id ? (
                  <video
                    src={`https://vaghfnama.ir/api/campaigns/api/v1/campaign_video_posts/${currentResult.video_post_campaign.id}/stream/`}
                    poster={baseURL + currentResult?.video_post_campaign?.cover}
                    controls
                    muted
                    volume={0.8}
                    loop={false}
                    preload="metadata"
                    width="100%"
                    height="auto"
                    style={{
                      objectFit: "cover", 
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    {" "}
                    مرورگر شما از ویدئو پشتیبانی نمی‌کند.{" "}
                  </video>
                ) : (
                  <LoadingIndicator />
                )}
              </div>
            </div>
            <div className="footer">
              <div className="details">
                <div>
                  <span className="title">مدال و رتبه:</span>
                  <span className="value">
                    {getMedalAndRank(currentResult?.video_medal)}
                  </span>
                </div>
                <div>
                  <span className="title">عنوان نتیجه:</span>
                  <span className="value">{currentResult?.title_result}</span>
                </div>
                <div>
                  <span className="title">معیار های انتخاب:</span>
                  <span className="value">
                    {currentResult?.selection_criteria}
                  </span>
                </div>
                <div>
                  <span className="title">فرمول انتخاب برنده:</span>
                  <span className="value" style={{ whiteSpace: "pre-line" }}>
                    {currentResult?.scoring_formula}
                  </span>
                </div>
                <div>
                  <span className="title">نام پویش:</span>
                  <span className="value">{currentResult?.campaign?.name}</span>
                </div>
                <div>
                  <span className="title">شعار پویش:</span>
                  <span className="value">
                    {currentResult?.campaign?.Terms_participation_in_campaign}
                  </span>
                </div>
                <div>
                  <span className="title">عنوان ویدئو:</span>
                  <span className="value">
                    {currentResult?.video_post_campaign?.title}
                  </span>
                </div>
                <div>
                  <span className="title">بازدید:</span>
                  <span className="value">
                    {currentResult?.video_post_campaign?.counted_views}
                  </span>
                </div>
                <div>
                  <span className="title">لایک:</span>
                  <span className="value">
                    {currentResult?.video_post_campaign?.counted_like}
                  </span>
                </div>
                <div>
                  <span className="title">دیسلایک:</span>
                  <span className="value">
                    {currentResult?.video_post_campaign?.counted_dislike}
                  </span>
                </div>
                <div>
                  <span className="title">ذخیره:</span>
                  <span className="value">
                    {currentResult?.video_post_campaign?.counted_save}
                  </span>
                </div>
                <div>
                  <span className="title">اشتراک:</span>
                  <span className="value">
                    {currentResult?.video_post_campaign?.counted_share}
                  </span>
                </div>
              </div>
              <img
                className="trophy"
                src={
                  currentResult?.video_medal === "Gold"
                    ? `/img/gold.svg`
                    : currentResult?.video_medal === "Silver"
                    ? `/img/silver.svg`
                    : currentResult?.video_medal === "Bronze"
                    ? `/img/bronze.svg`
                    : `/img/trophy.svg`
                }
                alt="Winner Trophy"
              />
            </div>
          </div>
        </Container>
      </ContentWrapper>
    </>
  );
};

export default CampaignResult;
